import { Component, OnDestroy, OnInit } from '@angular/core';
// Services
import { ViewsService } from '../../../../../../services/views.service';
import { ScrollableItemsHelperOsService } from '../../../../../services/scrollable-items-helper-os.service';
// Components
import { RoomLayoutBaseComponent } from '../../../common/room-layout/model/room-layout.base';
import { LayoutRenderService } from '../../../../services/layout-render.service';

@Component({
	selector: 'cv-schema-render-room34-layout',
	templateUrl: './room-layout.component.html',
	styleUrls: ['./room-layout.component.scss']
})
export class Room34LayoutComponent extends RoomLayoutBaseComponent implements OnInit, OnDestroy {
	// @Input() data: any;                                  // It being readed in the RoomLayoutBase
	// @Input() layoutNode = new LayoutRenderLayoutItem();  // It being readed in the RoomLayoutBase

	public layoutUIConfig: any = {};

	constructor(
		protected viewsService: ViewsService,
		protected layoutService: LayoutRenderService,
		protected scrollableHelper: ScrollableItemsHelperOsService
	) {
		super(viewsService, scrollableHelper);
	}

	ngOnInit(): void {
		this.init();
		// Attach Layout Config
		this.layoutUIConfig = this.layoutService.layout;
	}

	ngOnDestroy(): void {
		this.atComponentDestroy.next({});
		this.atComponentDestroy.unsubscribe();
	}
}
